<template>
  <v-snackbar
    v-model="props.snackbarSettings.show"
    :timeout="props.snackbarSettings.timer"
    :color="props.snackbarSettings.color"
    location="top right"
  >
    <div class="d-flex align-items-center">
      <span class="flex-grow-1">{{ props.snackbarSettings.message }}</span>

      <div class="flex-grow-0">
        <v-btn variant="text" @click="closeSnackbar">Close</v-btn>
      </div>
    </div>
  </v-snackbar>
</template>

<script setup>
const props = defineProps({
  snackbarSettings: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["updateSnackbarSettings"]);

const closeSnackbar = () => {
  emit("updateSnackbarSettings", {
    ...props.snackbarSettings,
    show: false,
  });
};
</script>
